const GRAPH_DATA_TYPES = {
  AUTOMATION_ACTIVATED: 'automation-activated',
  RECOGNITION_SENT: 'recognition-sent',
  ORDERS_SENT: 'orders-sent',
  ORDERS_SUBMITTED: 'orders-submitted',
  ORDERS_ACCEPTED: 'orders-accepted',
  TOTAL_SPENT: 'total-spent'
};

export { GRAPH_DATA_TYPES };
